<template>
    <div class="fale-conosco">
        <a
            v-if="showFaleConosco"
            href="mailto:conteudosvivo.br@telefonica.com"
            target="_blank"
            class="link_contato"
        >
            <div class="contato">
                <TituloLateral titulo="FALE CONOSCO" :temBotao="false" class="texto-branco" />
                <div class="link-email">
                    <div>
                        <img src="@/assets/imgs/icone_email.svg" />
                        <h5>conteudosvivo.br@telefonica.com</h5>
                    </div>
                </div>
            </div>
        </a>
    </div>
</template>

<script>
import TituloLateral from '@/components/layout/conteudo/TituloLateral.vue';
import env from '../../../config/env';

export default {
    name: 'FaleConosco',
    components: {
        TituloLateral,
    },
    computed: {
        showFaleConosco() {
            return env.revista.canal === env.canal.administrativo || env.revista.canal === env.canal.loja_propria;
        },
    },
};
</script>

<style scoped lang="scss">
@import '@/estilo/sass/_formulas.scss';
@import '@/estilo/sass/_cores.scss';

.fale-conosco {
    @extend %area-de-utilizacao;
    @extend %flex;
    @extend %direction-row;
    @extend %justify-center;
    @extend %align-items-center;
    margin: 0 auto;

    & /deep/.texto-branco {
        color: white;
        margin: 0px;

        & h2 {
            color: white;
            margin-top: -5px;
            margin-bottom: 5px;
            font-size: 30px;
        }
    }

    & .link_contato {
        text-decoration: none;

        &:hover > .contato {
            @extend %gradiente_roxo;
            -webkit-box-shadow: 0px 10px 30px 1px rgba(102, 0, 153, 0.35);
            -moz-box-shadow: 0px 10px 30px 1px rgba(102, 0, 153, 0.35);
            box-shadow: 0px 10px 30px 1px rgba(102, 0, 153, 0.35);
        }

        &:hover > .contato .link-email div {
            color: $cor_amarelo;
        }
    }

    & .contato {
        @extend %flex;
        @extend %align-items-center;
        @extend %direction-column;
        @extend %gradiente_roxo;
        width: 350px;
        padding: 24px 0;
        border-radius: 5px;
        transition: all 0.2s ease-in-out;

        &:hover {
            animation: grow 1s alternate;
        }

        & /deep/.texto-roxo {
            color: $cor_amarelo;

            & h2 {
                color: $cor_amarelo;
            }
        }

        & .link-email {
            @extend %flex;
            @extend %direction-column;

            & div {
                @extend %flex;
                @extend %direction-row;
                @extend %justify-center;
                @extend %align-items-center;
                width: 340px;
                color: $cor_amarelo;
                font-family: 'VivoType';
                font-weight: bold;
                font-size: 16px;
                text-transform: uppercase;
                text-decoration: none;

                & img {
                    margin-right: 10px;
                }

                & h5 {
                    margin: 0px;
                }
            }
        }
    }
}

@keyframes grow {
    0% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.05);
    }
    100% {
        transform: scale(1);
}
}

@media all and (min-width: 300px) and (max-width: 1000px) {
    .fale-conosco {
        flex-direction: column !important;
        max-width: calc(100vw - 70px);
        align-items: center;

        & .link_contato {
            margin-top: 10px;

            &:hover > .contato {
                -webkit-box-shadow: 0px 5px 15px 1px rgba(102, 0, 153, 0.35);
                -moz-box-shadow: 0px 5px 15px 1px rgba(102, 0, 153, 0.35);
                box-shadow: 0px 5px 15px 1px rgba(102, 0, 153, 0.35);
            }
        }

        & .contato {
            padding: 12px 0;

            &:hover {
                animation: none;
            }

            & /deep/.titulo-lateral {
                & h2 {
                    font-size: 16px !important;
                    padding: 0;
                    margin: 0px;
                }
            }

            & .link-email {
                & div {
                    width: calc(100vw - 70px);
                    font-size: 12px;

                    & img {
                        display: none;
                        margin-right: 10px;
                    }

                    & h5 {
                        margin: 0px;
                    }
                }
            }
        }
    }
}
</style>
